'use client'

export const isToolAnnotationRecord = (
  value: unknown
): value is Record<string, unknown> => typeof value === 'object' && value !== null && !Array.isArray(value)

export const unwrapToolAnnotationResult = <T = unknown>(value: unknown): T | undefined => {
  if (value == null) {
    return undefined
  }

  if (isToolAnnotationRecord(value) && 'result' in value) {
    return (value as { result?: T }).result
  }

  return value as T
}
